import parseGoal from '../../api/studentGoals/shared/studentGoalsParsers';
import { compareDataByMeasureYearGradePeriod } from './filterUtils';

const updateStudentGoals = (rawGoal, studentGoals = []) => {
    const studentGoal = parseGoal(rawGoal);
    const { measure, schoolYear, grade, period } = studentGoal;
    const goals = studentGoals.filter(
        goal => !compareDataByMeasureYearGradePeriod(goal, measure, schoolYear, grade, period),
    );
    return goals.concat(studentGoal);
};

export const updateDataObject = (data, rawGoal) => {
    const studentId = rawGoal.student_uid;
    return {
        ...data,
        [studentId]: updateStudentGoals(rawGoal, data[studentId]),
    };
};

export const studentGoalsParser = response =>
    response.reduce((goalsByStudent, rawGoal) => updateDataObject(goalsByStudent, rawGoal), {});
